/**
 * WeightDisc — el disco olímpico ONOR (45 LBS / 20.4 KG · MEX · EST. 2025),
 * render oficial. Loader y marca de carga de la identidad v2.1.
 * size — px (default 48). spinning — gira a velocidad constante (default true).
 */
const WeightDisc = ({ size = 48, spinning = true, className = '', label = 'Cargando' }) => (
  <img
    src="/brand/disc.webp"
    width={size}
    height={size}
    alt={label}
    draggable="false"
    className={`${spinning ? 'onor-disc-spin' : ''} ${className}`}
    style={{ width: size, height: size }}
  />
);

export default WeightDisc;
